module.exports = __webpack_public_path__ + "img/invoice-de-male-rp.f34967ff.png";